export const clearTokensFromLocalStorage = () => {
  window.localStorage.removeItem('JWT');
  window.localStorage.removeItem('refreshToken');
};
